import './ToggleSwitch.css';

// 押した瞬間に反映される設定専用。保存 / 実行ボタンで確定するフォームではチェックボックスを使う。
// ラベルは固定の肯定形 (状態で書き換えない)。詳細: .claude/rules/toggle-vs-checkbox.md

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function ToggleSwitch({ checked, onChange, label, disabled, className }: ToggleSwitchProps) {
  return (
    <div className="toggle-with-label">
      <label className={`toggle-switch ${className || ''}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          // 表示ラベルは label 要素の外にあるので、読み上げ名として input に直接付ける
          aria-label={label}
        />
        <span className="toggle-slider"></span>
      </label>
      {label && <span className="toggle-label-text">{label}</span>}
    </div>
  );
}
